module.exports = __webpack_public_path__ + "img/status-PAUSED-icon.8f35c6fa.svg";